module.exports = __webpack_public_path__ + "img/organization-timezone.f7b320ec.svg";